import Icon from '../components/Icon.vue'

Icon.register({
  'gas-pump': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M336 448c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-320c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h320zM493.2 107.3c12 12 18.8 28.3 18.8 45.3v223.4c0 42.2-36.5 76-79.5 71.7-37.5-3.9-64.5-38.2-64.5-75.9v-27.8c0-22.1-17.9-40-40-40h-8v112h-288v-352c0-35.3 28.7-64 64-64h160c35.3 0 64 28.7 64 64v192h8c48.6 0 88 39.4 88 88v32c0 13.2 10.8 24 24 24s24-10.8 24-24v-160.8c-27.1-3.9-48-27.1-48-55.2v-62.1l-37.7-37.7c-6.2-6.2-6.2-16.4 0-22.6l11.3-11.3c6.2-6.2 16.4-6.2 22.6 0zM256 192v-128h-160v128h160z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/gas-pump.js
// module id = 1323
// module chunks = 0